import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import {
  AUTH_CLIENT_VERSION,
  AuthSessionService,
} from '../services/auth-session/auth-session.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authSession: AuthSessionService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem('token');

    if (!this.isRhemaApiRequest(request.url)) {
      return next.handle(request);
    }

    const isSessionEndpoint = this.isSessionEndpoint(request.url);
    let authenticatedRequest = request.clone({
      setHeaders: {
        'X-Rhema-Client': 'web',
        'X-Rhema-Client-Version': AUTH_CLIENT_VERSION,
        'X-Rhema-Device-Id': this.authSession.getDeviceId(),
        'X-Rhema-Auth-Version': '2',
      },
    });

    if (token && !request.headers.has('Authorization')) {
      authenticatedRequest = authenticatedRequest.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    return next.handle(authenticatedRequest).pipe(
      catchError((error) => {
        if (isSessionEndpoint || !this.shouldRefresh(error)) {
          return throwError(() => error);
        }
        return this.authSession.refreshAccessToken().pipe(
          switchMap((accessToken) =>
            next.handle(
              authenticatedRequest.clone({
                setHeaders: { Authorization: `Bearer ${accessToken}` },
              })
            )
          )
        );
      })
    );
  }

  private isRhemaApiRequest(url: string): boolean {
    const apiUrl = environment.services.rhemaServer.replace(/\/$/, '');
    return url === apiUrl || url.startsWith(`${apiUrl}/`) || url.startsWith(`${apiUrl}?`);
  }

  private isSessionEndpoint(url: string): boolean {
    return /\/auth\/native\/(login|refresh|logout)(?:\?|$)/.test(url);
  }

  private shouldRefresh(error: { status?: number; error?: { code?: string } }): boolean {
    const refreshableCodes = ['TOKEN_EXPIRED', 'TOKEN_MISSING', 'TOKEN_INVALID', 'SESSION_REVOKED'];
    return navigator.onLine && error.status === 401 &&
      localStorage.getItem('isUserLoggedIn') === 'true' &&
      !!localStorage.getItem('refreshToken') &&
      refreshableCodes.includes(error.error?.code || '');
  }
}
